module.exports = __webpack_public_path__ + "static/media/tim.82c4a9e3.jpg";